import React from 'react';
import { Control, useController, useFieldArray } from "react-hook-form"
import { Inputs } from '../../../../containers/interviewReservationForm/interviewReservationFormService'
import { GItem } from "../../common/grids"
import { ButtonS } from '../../common/buttons/buttonS'
import { TempFileUploadField } from './tempFileUploadFiled'
import { translate } from '../../../../i18n'
import { FormHelperText, styled } from '@mui/material';

export interface TempFileFieldProps {
    childNum: number
    note: string
    tempFileNote: string
    control?: Control<Inputs>
}

const InformationAndNote = styled('div')({
    margin: '0',
    whiteSpace: 'pre-wrap',
  })

const TempFileField = (props: TempFileFieldProps) => {
    const { childNum, note, tempFileNote, control } = props;

    const uploadName = `children.${childNum}.tempFile.files` as `children.${number}.tempFile.files`
    const { fields, append } = useFieldArray({
        name: uploadName,
        control,
    })

    const {
        fieldState: { error }
    } = useController({
        control,
        name: uploadName, // このフィールドに対してバリデーションを設定
        rules: {},
        defaultValue: []
    });

    return (
        <GItem xs={12}>
            <div>{note}</div>
            <InformationAndNote>{tempFileNote}</InformationAndNote>
            {error && <FormHelperText>{error.message}</FormHelperText>}
            <div>
                {fields.map((item, docIndex) => (
                    <TempFileUploadField
                        key={item.id}
                        name={`${uploadName}.${docIndex}`}
                        registeredFileKey={item.tempUploadKey}
                    />
                ))}
                {fields?.length < 5 && (
                    <GItem
                        xs={12}
                        mt={1}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <ButtonS
                            sx={{ width: 'fit-content' }}
                            onClick={() => append({
                                fileName: null,
                                delFlg: '0',
                                tempUploadKey: null,
                            })}
                        >
                            {translate('interviewReservationForm.button.tempFile.add')}
                        </ButtonS>
                    </GItem>
                )}
            </div>
        </GItem>
    );
}

export default TempFileField;
